import { Divider, LoadingOverlay, Stack, Text } from '@mantine/core';
import "../styles/Highlight.css"
import { useEffect, useState } from 'react';
import supabase from '../api/client';


export const HighlightInfo = ({ id }) => {
  const [data, setData] = useState(null)
  const [visible, setVisible] = useState(true);

  async function getHighlightData(id) {
    const { data } = await supabase.from("Highlight").select("Event (name), Game (name), Team (name), Player (name), title").eq("id", id)
    setData(...data)
    setVisible(false)
  }

  useEffect(() => {
    getHighlightData(id)
  }, [])

  return (
    <>
      <Stack
        justify="center"
      >
        <LoadingOverlay visible={visible} zIndex={1000} overlayProps={{ color: "#212121", backgroundOpacity: 0.5, blur: 10 }} />
        <Divider></Divider>
        <Text>Title: </Text>
        <Text styles={{root: {textAlign: "right"}}}>{data ? data.title : null}</Text>
        <Divider></Divider>
        <Text>Event: </Text>
        <Text styles={{root: {textAlign: "right"}}}>{data ? data.Event.name : null}</Text>
        <Divider></Divider>
        <Text>Game: </Text>
        <Text styles={{root: {textAlign: "right"}}}>{data ? data.Game.name : null}</Text>
        <Divider></Divider>
        <Text>Player: </Text>
        <Text styles={{root: {textAlign: "right"}}}>{data ? data.Team.name + " " + data.Player.name : null}</Text>
      </Stack>
    </>
  )
}
